<template>
    <div>
        <transition name="slide-fade" mode="out-in">
            <div class="side-bar" v-if="isShowSideBar">
                <div class="area-menu-bar">
                    <div class="menu-close" @click="clickCloseMenu()">
                        <img src="@/assets/icon/sidebar/menu_icon_close.svg" />
                    </div>
                    <div class="menu-wrapper">
                        <!-- area top menu -->
                        <div class="menu-profile">
                            <div class="logo-header">
                                <div class="logo-bio">
                                    <img :src="$store.getters.getLogoBioderma" alt="">
                                </div>
                                <div class="logo-naos">
                                    <img :src="$store.getters.getLogoNao" alt="">
                                </div>
                            </div>
                            <div class="login" v-if="isUserLogin">
                                <div class="profile-image" >
                                    <img :src="linePicture" />
                                </div>
                                <div class="text-name">
                                    <div>{{profile.firstName}} {{profile.lastName}}</div>
                                    <div class="line"></div>
                                    <div class="your-point">คุณมีพอยท์ <span>{{userPoint | number_format}}</span>
                                        <img src="@/assets/icon/sidebar/point-icon.svg">
                                    </div>
                                    <div class="point-expired" v-html="expirePointDate"></div>
                                </div>
                            </div>
                            <div v-else class="no-login">
                                <div class="profile-pic">
                                    <img src="@/assets/icon/sidebar/menu_pic_iser.svg">
                                </div>
                                <div class="text-login">
                                    <div>
                                        กรุณาเข้าสู่ระบบก่อนใช้งาน
                                    </div>
                                    <div class="line"></div>
                                    <div class="btn-login" @click="clickLogin()">
                                        <div class="text">เข้าสู่ระบบ</div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- area list menu -->
                        <div class="menu-list-bar">
                            <div class="menu-list">
                                <div class="menu-item" @click="gotoProfile('/profile')"
                                    v-if="isUserLogin">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_profile.svg">
                                    <div class="menu-txt">ข้อมูลส่วนตัว</div>
                                </div>
                                <div class="menu-item" @click="goto('rewards')">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_reward.svg">
                                    <div class="menu-txt">สิทธิพิเศษ</div>
                                </div>
                                <div class="menu-item" @click="goto('luckydraw')" v-if="isUserLogin && isShowLuckydraw">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_draw.svg">
                                    <div class="menu-txt">ลุ้นรางวัล</div>
                                </div>
                                <!-- <div class="menu-item">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_news.svg">
                                    <div class="menu-txt">ข่าวสารและกิจกรรม</div>
                                </div> -->
                                <div class="menu-item" @click="goto('history/earn')" v-if="isUserLogin">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_earnpoint2.svg">
                                    <div class="menu-txt">ประวัติการสะสมพอยท์</div>
                                </div>
                                <div class="menu-item" @click="goto('history/burn')" v-if="isUserLogin">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_burnpoint2.svg">
                                    <div class="menu-txt">ประวัติการแลกพอยท์</div>
                                </div>
                                <div class="menu-item" @click="goto('point/guide')">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_point.svg">
                                    <div class="menu-txt">พอยท์แต่ละสินค้า</div>
                                </div>
                                <div class="menu-item" @click="goto('privacy')">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_tc.svg">
                                    <div class="menu-txt">นโยบายความเป็นส่วนตัว</div>
                                </div>
                                <div class="menu-item"  @click="goto('terms')">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_accept.svg">
                                    <div class="menu-txt">เงื่อนไขการใช้สิทธิพิเศษ</div>
                                </div>
                                <div class="menu-item" @click="goto('about')">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_information.svg">
                                    <div class="menu-txt">เกี่ยวกับเรา</div>
                                </div>
                                <div class="menu-item" @click="goto('contact')">
                                    <img class="menu-ic" src="@/assets/icon/sidebar/menu_icon_contact.svg">
                                    <div class="menu-txt">ติดต่อเรา</div>
                                </div>
                                <div class="menu-bottom">
                                    <div class="text-bottom">ติดตามเรา</div>
                                    <div class="wrapper-social">
                                        <div class="social-logo">
                                            <img @click="clickFacebook()" class="img-fluid" src="@/assets/icon/sidebar/menu_icon_facebook.svg">
                                            <img @click="clickIg()" class="img-fluid" src="@/assets/icon/sidebar/menu_icon_ig.svg">
                                        </div>
                                        <div class="bzbs-logo">
                                            <img class="img-fluid" src="@/assets/bzbslogo/bzbs-new-logo-white.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </transition>
            <div class="sidebar-backdrop"
                :class="{'active' : isShowSideBar}"
                @click="clickCloseMenu()"
            ></div>
    </div>

</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//helper
import Account from "@/helper/AccountHelper.js";
import CacheHelper from "@/helper/CacheHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
//service
import LuckyDrawBlob from "@/module/Luckydraw/service/LuckyDrawBlob.js";
// import Service from "@/core/Blob/BlobService";
export default {
    name: 'SideBar',
    mixins: [AccountMixin],
    props:{
        isShowSideBar: Boolean,
        expirePointDate: String
    },
    data: function() {
        return {
            isUserLogin: false,
            linePicture: null,
            userPoint: 0,
            dateLatest: '',
            currentPath: null,
            isShowLuckydraw: false,
            tracking: new TrackingService(this),
        };
    },
    computed: {
        isSideMenuActive: {
            get: function() {
                return this.$store.getters.isShowSideBar;
            },
        },
    },
    created: function() {
        this.getAccountData();

        if(Account.isLogin()){
            this.isUserLogin = true;
            this.linePicture = this.getPictureLine();
            this.getPoint();
            this.getShowMenuLuckyDraw();
            this.tracking.screenName('Side_Menu');
        }
    },
    mounted: function(){
        this.currentPath = this.$router.currentRoute.path;
    },
    methods: {
        clickLogin:function () {
            window.location.replace('/linelogin');
        },
        clickCloseMenu: function() {
            this.$emit("clickMenu", false);
        },
        getPoint: function() {
             Account.apiGetPoint().then((data) =>{
                this.userPoint = data.points;
            });
        },
        gotoProfile: function(path) {
            this.$router.push(path);
            this.tracking.event('profile', 'click_profile');
        },
        goto: function(target) {
            var path = `/${target}`;

            //for history
            var cache = new CacheHelper('session');
            if(target == 'history/burn'){
                cache.setCache('FromPage', this.currentPath);
            }

            if (target == "/about");
            else if (target == "/contact");
            if (path != this.currentPath) this.$router.push(path);

            switch (path){
                case '/rewards' :
                    this.tracking.event('reward', 'click_reward');
                    break;
                case '/history/earn' :
                    this.tracking.event('point_earn', 'click_point_earn');
                    break;
                case '/history/burn' :
                    this.tracking.event('point_burn', 'click_point_burn');
                    break;
                case '/point/guide' :
                    this.tracking.event('point_guideline', 'click_point_guideline');
                    break;
                case '/privacy' :
                    this.tracking.event('privacy_policy', 'click_privacy_policy');
                    break;
                case '/terms' :
                    this.tracking.event('term_and_condition', 'click_term_and_condition');
                    break;
                case '/about' :
                    this.tracking.event('about_us', 'click_about_us');
                    break;
                case '/contact' :
                    this.tracking.event('cotact_us', 'click_contact_us');
                    break;
            }
        },
        clickFacebook: function () {
            window.open("https://www.facebook.com/BIODERMAThailand/");
        },
        clickIg: function () {
            window.open("https://www.instagram.com/bioderma_thailand_official/?hl=en");
        },
        getShowMenuLuckyDraw: function () {
            LuckyDrawBlob.apiGetMenuLuckyDrawBlob().subscribe((res) => {
                this.isShowLuckydraw = res.showMenuLuckydraw;
                console.log("apiGetLuckyDrawBlob", this.isShowLuckydraw);
            }, (err) => {
                this.errorApi(err);
            });
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseUtility.scss";
@import "./SideBar.scss";
</style>
